import React, { Suspense, useEffect, useRef, useState } from "react";
import style from "./style.module.css";
import FlexTitleComponent from "../../Trade/Listing/HomepageRevamp4.0/FlexTitle/FlexTitleComponent";
import HeadLines from "../../CommonComponents/HeadLines";
import { alerttriangle, RightGreenTick } from "../../icon_assets";
import { HomePageServices } from "../../../../../_services/Arya2.0/HomePageServices";
import useIsUserLoggedIn from "../../CustomHooks/useIsUserLoggedIn";
import Registration from "../../Registration/Registration";
import EmailRegisterPopUp from "../../Registration/EmailRegisterPopUp";
import EmailLinkSentPopUp from "../../Registration/EmailLinkSentPopUp";
import { useClickOutside } from "../../CustomHooks/useClickOutside";
import useUserDetails from "../../CustomHooks/useUserDetails";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { eventTracker } from "../../GATracker3.0/eventTracker";
import {
  addInfoNotificationValue,
  NOTIFICATION_CLICKED,
} from "../../GATracker3.0/constants";

function AlertsNotification() {
  const ref = useRef();
  const flag = useClickOutside(ref);
  const userData = useUserDetails();
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [userLoggedIn] = useIsUserLoggedIn();
  const [regShow, setRegShow] = useState(false);
  const [showEmailVerifyPopUp, setShowEmailVerifyPopUp] = useState(false);
  const [showEmailSentPopUp, setShowEmailSentPopUp] = useState(false);
  const [email, setEmail] = useState("");
  const history = useHistory();

  useEffect(() => {
    if (flag) {
      setShow(false);
    }
  }, [flag]);

  const modifyData = (dataArray) => {
    const newArray = dataArray.map((obj) => {
      const [date, time] = obj.created_at.split("T");

      return {
        title: obj.title,
        body: obj.body,
        finance:
          obj.type === "LOAN_DISBURSEMENT" || obj.type === "RELEASE_STOCK"
            ? true
            : false,
        onClick: () => handleNotificationClick(obj),
        date: date,
        time: time.split(".")[0],
        icon: alerttriangle || "default_icon",
      };
    });
    setData(newArray);
  };

  const handleNotificationClick = (obj) => {
    getNotificationReadData(obj);
    eventTracker("event", NOTIFICATION_CLICKED, {
      pagename: "notification",
      addinfo: addInfoNotificationValue[obj.type],
    });
    redirectUrl(obj);
  };

  const redirectUrl = (dataObj) => {
    switch (dataObj.type) {
      case "LOAN_DISBURSEMENT":
        history.push(`/disbursement/${dataObj?.reference_data?.sr_id}`);
        break;
      case "RELEASE_STOCK":
        history.push(
          `/arya2/release-stock/${dataObj?.reference_data?.warehouse_code}/${dataObj?.reference_data?.commodity_id}/${dataObj?.reference_data?.contract_id}`
        );
        break;
      case "LEAD_QUOTATION":
        history.push(
          `/buyer-requirements/${dataObj?.reference_data?.unique_id}`
        );
        break;
      case "SPOT_CONTRACT_CREATION":
        history.push(`/view-contract/${dataObj?.reference_data?.contract_id}`);
        break;
      case "COMMODITY_INWARD":
        history.push(`/token-details/${dataObj?.reference_data?.token_hash}`);
        break;
      case "EMAIL_VERIFICATION":
        handleEmailVerifyPopUp();
        break;
      default:
        setRegShow(true);
        break;
    }
  };

  const handleEmailVerifyPopUp = () => {
    setShowEmailVerifyPopUp(true);
    setEmail(userData.email);
  };

  const getNotificationReadData = async (data) => {
    try {
      const obj = { id: data.id };
      await HomePageServices.getUserReadNotification(obj);
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const getNotificationData = async () => {
    try {
      const res = await HomePageServices.getUserNotification();
      if (res?.data?.length) {
        modifyData(res.data);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    if (userLoggedIn) {
      getNotificationData();
    } else {
      setData([]);
    }
  }, [userLoggedIn]);

  useEffect(() => {
    if (show && ref?.current) {
      ref.current.click();
    }
  }, [show]);

  return (
    <>
      {regShow && (
        <Suspense fallback={<></>}>
          <Registration show={regShow} setShow={setRegShow} />
        </Suspense>
      )}
      {showEmailVerifyPopUp && (
        <EmailRegisterPopUp
          setShowEmailVerifyPopUp={setShowEmailVerifyPopUp}
          showEmailVerifyPopUp={showEmailVerifyPopUp}
          setEmail={setEmail}
          email={email}
          setShowEmailSentPopUp={setShowEmailSentPopUp}
          showVerifyEmailPopUSent={true}
        />
      )}
      {showEmailSentPopUp && (
        <EmailLinkSentPopUp
          setShowEmailSentPopUp={setShowEmailSentPopUp}
          showEmailSentPopUp={showEmailSentPopUp}
          email={email}
        />
      )}
      {data.length > 0 && (
        <div>
          <FlexTitleComponent
            title={"Alerts & Notifications"}
            customClass={`${style["marginTop5"]}`}
          />
          <div
            className={`padding16 margin-top20 boxRadius8 ${style["backBorderColor"]}`}
          >
            {data.map((ele, index) => (
              <div
                className={`d-flex align-items-center gap14 ${
                  index < data.length - 1
                    ? `${style["borderBottom"]} padding-bottom16 margin-bottom16`
                    : ""
                }`}
                key={index}
                onClick={ele.onClick}
                role="button"
                tabIndex={0}
              >
                <div
                  className={`${style["roundCircle"]} ${
                    ele?.icon === RightGreenTick
                      ? style["greenBackground"]
                      : style["yellowBackground"]
                  }`}
                >
                  <img
                    src={ele?.icon}
                    alt="Notification Icon"
                    height={10}
                    width={10}
                  />
                </div>
                <div>
                  <HeadLines
                    text={ele.title}
                    className={`margin-bottom4 font-size16 line-height19 font-weight500 ${style["titleColor"]}`}
                  />
                  <HeadLines
                    text={`${ele.date}, ${ele.time}`}
                    className={`margin-bottom4 font-size16 line-height19 font-weight500 ${style["subTitleColor"]}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default AlertsNotification;
